// TopBar — 54px desktop header with avatar dropdown.
//
// The breadcrumb, search bar, and notification bell are intentional
// follow-ups — they each need backend / state plumbing (breadcrumb depends
// on the current route; search hits discovery; the bell needs the
// notification feed) and don't belong in a chrome-only PR.
import UserMenu from './UserMenu'

export default function TopBar() {
  return (
    <header className="h-[54px] bg-[var(--surface)] border-b border-[var(--border-subtle)] flex items-center gap-3 px-5 flex-shrink-0">
      <div className="flex-1" />
      <UserMenu variant="app" />
    </header>
  )
}
